import { MenuProps } from 'components/Menu/Types'
import { observer } from 'mobx-react-lite'
import { useAlmanacEditorState } from 'stores/EditorState'
import { TextColorPicker } from 'common/Prose/components/TextColorPicker/TextColorPicker'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { computed } from 'mobx'
import Styles from './ColorPicker.module.scss'

export const TextColorPickerSubMenu = observer(({ onAction }: Pick<MenuProps<any>, 'menuType' | 'onAction'>) => {
  const editorState = useAlmanacEditorState()
  const view = useEditorView()

  const activeColors = computed(() => editorState?.activeColors && Array.from(editorState.activeColors)).get() || []

  return (
    <span className={Styles.root}>
      <TextColorPicker view={view} activeColors={activeColors} callback={() => onAction?.('')} />
    </span>
  )
})
